import { useMemo } from "preact/hooks";
import PropTypes from "prop-types";

export default function Picker({
  items = [{ name: "Empty", value: "null" }],
  currentValue,
  fieldName,
  onChange,
  labelText,
  hidden = false,
  loading = false,
  disabled = false,
  label = null,
  className = null,
  emptyLabel = "Please pick a value",
  description = null,
}) {
  if (hidden) {
    return null;
  }

  let skeletonBlock;

  function filterOnChange(e) {
    if (`${e.target.value}`.length > 0) {
      onChange(e);
    }
  }

  if (loading) {
    if (labelText || label) {
      skeletonBlock = (
        <div className="skeleton absolute top-[5px] bottom-[25px] rounded-field left-0 right-0" />
      );
    } else {
      skeletonBlock = (
        <div className="skeleton absolute top-0 bottom-0 left-0 right-0 rounded-field" />
      );
    }
  }

  const options = useMemo(() => {
    return items.map((item) => {
      if (currentValue === item.value && currentValue !== null) {
        return (
          <option key={item.value} value={item.value} selected>
            {item.name}
          </option>
        );
      } else if (item.value !== "empty") {
        return (
          <option key={item.value} value={item.value}>
            {item.name}
          </option>
        );
      } else {
        return (
          <option key="empty-item" value="">
            {emptyLabel}
          </option>
        );
      }
    });
  }, [items, currentValue, emptyLabel]);

  if (!labelText && !label) {
    return (
      <fieldset
        className={
          className ? `relative fieldset w-full pl-1 ${className}` : "relative fieldset w-full pl-1"
        }
      >
        <select
          className="select w-full"
          onChange={filterOnChange}
          name={fieldName}
          disabled={disabled || loading}
        >
          {options}
        </select>
        {description && <p className="fieldset-label">{description}</p>}
        {skeletonBlock}
      </fieldset>
    );
  } else {
    return (
      <fieldset
        className={className ? `fieldset w-full relative ${className}` : "fieldset w-full relative"}
      >
        <legend className="fieldset-legend select-none -mb-0.5 pb-0">{labelText ?? label}</legend>
        <select
          className="select select-bordered relative w-full"
          onChange={filterOnChange}
          name={fieldName}
          disabled={disabled || loading}
        >
          {options}
        </select>
        {description && <p className="fieldset-label select-none">{description}</p>}
        {skeletonBlock}
      </fieldset>
    );
  }
}

Picker.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentValue: PropTypes.any,
  fieldName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  hidden: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  label: PropTypes.node,
  className: PropTypes.string,
  description: PropTypes.string,
};
